import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { makeSequence } from 'dpl/shared/utils';
import { isLessThanBreakpoint } from 'dpl/util/grid';

import SkeletonBlock from '../design_system/SkeletonBlock';

const IS_LT_MD = isLessThanBreakpoint('md');

export default function TransportationSectionSkeleton({ className }) {
  return (
    <div className={classnames('TransportationSectionSkeleton', className)}>
      <SkeletonBlock
        className="font-28 md:font-40 mb2 mb4-md"
        height="1.2em"
        width="30%"
      />
      <SkeletonBlock
        className="font-14 md:font-18 mb6 mb12-md"
        height="1em"
        width="35%"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-24 md:gap-96">
        <div>
          <SkeletonBlock
            className="font-24 mb6 mb8-md"
            height="1.2em"
            width="70%"
          />
          <div className="pb4 pb6-md">
            <div className="flex items-center gap-16">
              <SkeletonBlock
                className="ba b--default br3 ph2 pv2 ph3-md pv3-md flex-none"
                height={IS_LT_MD ? '40px' : '48px'}
                width={IS_LT_MD ? '40px' : '48px'}
              />
              <div className="flex flex-column gap-2 md:gap-4 w-100">
                <SkeletonBlock
                  className="font-14 md:font-18"
                  height="1em"
                  width="50%"
                />
                <SkeletonBlock
                  className="font-14 md:font-18"
                  height="1em"
                  width="75%"
                />
              </div>
            </div>
          </div>
          <SkeletonBlock
            className="br3"
            height={IS_LT_MD ? '200px' : '226px'}
            maxWidth="424px"
          />
        </div>
        <div>
          <SkeletonBlock
            className="font-24 mb6 mb8-md"
            height="1.2em"
            width="70%"
          />
          <div className="font-16 md:font-18 mb6 mb8-md">
            {makeSequence(2).map(index => (
              <div
                key={index}
                className={
                  index === 0 ? 'pb4 pb6-md' : 'bt b--default pt4 pt6-md'
                }
              >
                <div className="flex items-center gap-16">
                  <SkeletonBlock
                    className="ba b--default br3 ph2 pv2 ph3-md pv3-md flex-none"
                    height={IS_LT_MD ? '40px' : '48px'}
                    width={IS_LT_MD ? '40px' : '48px'}
                  />
                  <div className="flex flex-column gap-2 md:gap-4 w-100">
                    <SkeletonBlock
                      className="font-14 md:font-18"
                      height="1em"
                      width="50%"
                    />
                    <SkeletonBlock
                      className="font-14 md:font-18"
                      height="1em"
                      width="75%"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <SkeletonBlock className="ba b--default br12" height="88px" />
        </div>
      </div>
    </div>
  );
}

TransportationSectionSkeleton.propTypes = {
  className: PropTypes.string
};

TransportationSectionSkeleton.defaultProps = {
  className: null
};
